import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

// No explicit width/height: html2canvas re-lays the clone out itself, and forcing the measured
// height clipped the last line of every metric tile.
const shoot = (node, scale) => html2canvas(node, {
  scale, backgroundColor: "#ffffff", useCORS: true, logging: false, imageTimeout: 4000,
  windowWidth: node.scrollWidth,
});

const settle = () => new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));

// One section = one landscape sheet, scaled to fit whole, so nothing is ever cut mid-table.
export async function pdfFromContainer(container, pageSelector = ".print-page", { orientation = "landscape", scale = 1.6, pad = 14 } = {}) {
  container.classList.add("pdf-exporting");
  await settle();
  try {
    const pages = Array.from(container.querySelectorAll(pageSelector)).filter((el) => el.offsetHeight > 2);
    if (!pages.length) throw new Error("nothing to export");
    const pdf = new jsPDF({ unit: "pt", format: "a4", orientation });
    const pw = pdf.internal.pageSize.getWidth() - pad * 2;
    const ph = pdf.internal.pageSize.getHeight() - pad * 2;
    for (let i = 0; i < pages.length; i++) {
      const canvas = await shoot(pages[i], scale);
      if (!canvas.width || !canvas.height) throw new Error("a page could not be rendered");
      if (i) pdf.addPage();
      const ratio = Math.min(pw / canvas.width, ph / canvas.height);
      const w = canvas.width * ratio;
      const h = canvas.height * ratio;
      pdf.addImage(canvas.toDataURL("image/jpeg", 0.92), "JPEG", pad + (pw - w) / 2, pad + (ph - h) / 2, w, h);
    }
    return { pdf, pages: pages.length };
  } finally {
    container.classList.remove("pdf-exporting");
  }
}

export const savePdfFromContainer = async (container, filename, pageSelector, opts) => {
  const { pdf, pages } = await pdfFromContainer(container, pageSelector, opts);
  pdf.save(filename);
  return pages;
};

export const base64FromContainer = async (container, pageSelector, opts) => {
  const { pdf, pages } = await pdfFromContainer(container, pageSelector, opts);
  return { content: pdf.output("datauristring").split(",")[1], pages };
};
